import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "with-side-panel" }
const _hoisted_2 = { class: "content-i" }
const _hoisted_3 = { class: "content-box" }
const _hoisted_4 = { class: "element-wrapper" }
const _hoisted_5 = { class: "element-box" }
const _hoisted_6 = { class: "card shadow-sm border-0 mb-4" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-lg-6 col-md-12 col-sm-12" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-9" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-lg-6" }
const _hoisted_15 = { class: "col-lg-6" }
const _hoisted_16 = { class: "col-lg-6 col-md-12 col-sm-12" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-lg-9 col-md-12 col-sm-12" }
const _hoisted_19 = { class: "col-lg-3 col-md-12 col-sm-12" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-lg-6 col-md-12 col-sm-12" }
const _hoisted_22 = { class: "col-lg-3 col-md-12 col-sm-12" }
const _hoisted_23 = { class: "col-lg-3 col-md-12 col-sm-12" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-lg-6 col-md-12 col-sm-12" }
const _hoisted_26 = { class: "col-lg-6 col-md-12 col-sm-12" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_29 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_30 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_31 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_34 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_35 = { class: "card shadow-sm border-0 mb-4" }
const _hoisted_36 = { class: "card-body" }
const _hoisted_37 = { class: "row align-items-start" }
const _hoisted_38 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_39 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_40 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_41 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_42 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_43 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_44 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_45 = { class: "card shadow-sm border-0 mb-4" }
const _hoisted_46 = { class: "card-body" }
const _hoisted_47 = { class: "row gx-2 align-items-start" }
const _hoisted_48 = { class: "col-12 col-md-6 col-lg-3 mb-3" }
const _hoisted_49 = { class: "col-12 col-md-6 col-lg-3 mb-3" }
const _hoisted_50 = {
  class: "logo-preview d-flex justify-content-center align-items-center rounded",
  style: {"width":"100%","height":"200px","max-height":"200px","overflow":"hidden","border":"1px solid rgba(0, 0, 0, 0.15)","background-color":"#f8f9fa"}
}
const _hoisted_51 = ["src"]
const _hoisted_52 = {
  key: 1,
  class: "text-muted small"
}
const _hoisted_53 = { class: "col-12 col-md-4 col-lg-2 mb-3 d-flex flex-column align-items-center text-center" }
const _hoisted_54 = { class: "col-12 col-md-8 col-lg-4 mb-3" }
const _hoisted_55 = {
  class: "p-3 rounded border",
  style: {"background-color":"rgba(0, 0, 0, 0.02)","border-color":"rgba(0, 0, 0, 0.1) !important"}
}
const _hoisted_56 = { class: "row gx-2" }
const _hoisted_57 = { class: "col-12 col-sm-4 mb-2 mb-sm-0" }
const _hoisted_58 = { class: "col-12 col-sm-4 mb-2 mb-sm-0" }
const _hoisted_59 = { class: "col-12 col-sm-4" }
const _hoisted_60 = { class: "card shadow-sm border-0 mb-4" }
const _hoisted_61 = { class: "card-body p-4" }
const _hoisted_62 = { class: "row align-items-start" }
const _hoisted_63 = { class: "col-lg-2 col-md-4 col-sm-6" }
const _hoisted_64 = { class: "col-lg-2 col-md-4 col-sm-6" }
const _hoisted_65 = { class: "col-lg-2 col-md-4 col-sm-6" }
const _hoisted_66 = { class: "col-lg-2 col-md-4 col-sm-6" }
const _hoisted_67 = { class: "col-lg-2 col-md-4 col-sm-6" }
const _hoisted_68 = { class: "col-lg-2 col-md-4 col-sm-6" }
const _hoisted_69 = { class: "col-lg-2 col-md-4 col-sm-6" }
const _hoisted_70 = { class: "col-lg-2 col-md-4 col-sm-6" }
const _hoisted_71 = { class: "col-lg-2 col-md-4 col-sm-6" }
const _hoisted_72 = { class: "col-lg-2 col-md-4 col-sm-6" }
const _hoisted_73 = { class: "col-lg-2 col-md-4 col-sm-6" }
const _hoisted_74 = { class: "card shadow-sm border-0 mb-4" }
const _hoisted_75 = { class: "card-body p-4" }
const _hoisted_76 = { class: "row align-items-start" }
const _hoisted_77 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_78 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_79 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_80 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_81 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_82 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_83 = { class: "card shadow-sm border-0 mb-4" }
const _hoisted_84 = { class: "card-body p-4" }
const _hoisted_85 = { class: "row align-items-start" }
const _hoisted_86 = { class: "col-lg-2 col-md-4 col-sm-6" }
const _hoisted_87 = { class: "col-lg-2 col-md-4 col-sm-6" }
const _hoisted_88 = { class: "form-buttons-w text-center mt-5" }

import {computed, onMounted, ref, watch} from 'vue';
import {useVuelidate} from '@vuelidate/core';
import {isValidEmail, requiredRule} from '@/shared/validators/validationRules';
import {ErrorToast, SuccessToast} from '@/components/VueToast';
import companySettingsService from '@/api/CompanySettings/index';
import SaveButton from '@/components/button/SaveButton.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseDropzoneImage from "@/components/base/BaseDropzoneImage.vue";
import {ICompanySettings} from "@/interfaces/CompanySettings/ICompanySettings";
import {useI18n} from "vue-i18n";
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";
import BaseColorPicker from "@/components/BaseColorPicker.vue";
import BaseCheckbox from "@/components/base/BaseCheckbox.vue";
import SelectedDropdown from "@/components/SelectDropdown.vue";
import ValidationErrorMessage from "@/components/ValidationErrorMessage.vue";
import {piniaEnumsStore} from "@/store/piniaEnumsStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const {t} = useI18n();
const logo = ref<File[]>([])

const piniaEnumsState = piniaEnumsStore();
const {companyKeys} = computed(() => piniaEnumsState.enums).value;

const formData = ref<ICompanySettings>({
  //----- Company information -----
  name: '',
  shortName: '',
  companyKey: '',
  address: '',
  houseNumber: '',
  city: '',
  zip: '',
  country: '',
  email: '',
  contactPerson: '',
  website: '',
  phoneNumber: '',
  managingDirector1: '',
  managingDirector2: '',

  registrationPlace: '',
  registrationCourt: '',
  registrationNumber: '',
  instituteIdentifier: '',

  taxNumber: '',
  iban: '',
  swift: '',
  bank: '',
  accountingContactPerson: '',
  accountingEmail: '',
  accountingPhoneNumber: '',
  logoUrl: '',
  logoFile: null,
  colorCode: '',
  sidebarColorCode: '',
  sidebarIconColorCode: '',
  sidebarLinkColorCode: '',


  //----- Modules -----
  // client
  clientEnabled: false,
  subClientEnabled: false,

  // locations
  locationEnabled: false,

  // course
  coursePrivateCoachingEnabled: false,
  courseGroupCoachingEnabled: false,
  coursePrivateLearningCoachingEnabled: false,
  courseAssistedLivingCoachingPriceEnabled: false,
  courseSocioTherapyCoachingPriceEnabled: false,

  // coaching
  privateCoachingEnabled: false,
  privateCoachingEmail: '',
  groupCoachingEnabled: false,
  groupCoachingEmail: '',
  privateLearningCoachingEnabled: false,
  privateLearningCoachingEmail: '',
  assistedLivingCoachingEnabled: false,
  assistedLivingCoachingEmail: '',
  socioTherapyCoachingEnabled: false,
  socioTherapyCoachingEmail: '',
  caseManagementCoachingEnabled: false,
  caseManagementCoachingEmail: '',

  // billing
  billingEnabled: false,
  coachBillingEnabled: false,

  unemployedEnabled: false,
  analyticsEnabled: false,
  calendarEnabled: false,
  timeManagementEnabled: false,
  holidayEnabled: false,
  travelExpensesEnabled: false,
  userEnabled: false,
  addressBookEnabled: false,
  aiDocumentScanEnabled: false,
  deletedRecordsEnabled: false
});

const rules = ref<Record<string, any>>({
  name: requiredRule(t),
  shortName: requiredRule(t),
  companyKey: requiredRule(t),
  address: requiredRule(t),
  houseNumber: requiredRule(t),
  city: requiredRule(t),
  zip: requiredRule(t),
  country: requiredRule(t),
  email: isValidEmail(t),
  contactPerson: requiredRule(t),
  website: requiredRule(t),
  phoneNumber: requiredRule(t),
  managingDirector1: requiredRule(t),
  accountingContactPerson: requiredRule(t),
  registrationNumber: requiredRule(t),
  registrationPlace: requiredRule(t),
  registrationCourt: requiredRule(t),
  taxNumber: requiredRule(t),
  iban: requiredRule(t),
  swift: requiredRule(t),
  bank: requiredRule(t),
  instituteIdentifier: requiredRule(t)
});

const computedRules = computed(() => rules.value);
const v$ = useVuelidate(computedRules, formData);

const isSubmitting = ref(false);


async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) return;

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    const uploadData = new FormData();

    uploadData.append('body', JSON.stringify(formData.value));

    if (logo.value) {
      uploadData.append('logo', logo.value[0]);
    }

    logo.value = [];
    await companySettingsService.saveSettings(uploadData);
    await loadSettings(true);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function loadSettings(refreshPiniaState: boolean = false) {
  try {
    const {data} = await companySettingsService.getSettings();
    formData.value = {
      ...({} as ICompanySettings),
      ...data?.data,
      colorCode: data?.data?.colorCode ?? '#1b55e2',
      sidebarColorCode: data?.data?.sidebarColorCode ?? '#293145',
      sidebarIconColorCode: data?.data?.sidebarIconColorCode ?? '#293145',
      logoUrl: data?.data?.logoUrl ?? ''
    };

    if (data?.data?.logoUrl) {
      formData.value.logoUrl = data?.data?.logoUrl;
    }

    if (refreshPiniaState) {
      const store = piniaCompanySettingsStore();
      store.companySettings = {...data.data};
    }
  } catch (error) {
    await ErrorToast(error);
  }
}


watch(logo, (newFiles) => {
  const file = newFiles?.[0] || null
  if (!file) return

  const allowedFormats = ['image/jpeg', 'image/jpg', 'image/png']
  if (!allowedFormats.includes(file.type)) {
    logo.value = []
    const toastObj = {
      response: {
        data: {
          error: {
            message: ['Zulässige Bildformate sind: JPG, JPEG, PNG']
          }
        }
      }
    };
    ErrorToast(toastObj)
  }
})


watch(() => formData.value.privateCoachingEnabled, (val) => {
  if (!val) {
    formData.value.privateCoachingEmail = null
    rules.value = {...rules.value, privateCoachingEmail: ''};
  } else {
    // rules.value = {...rules.value, privateCoachingEmail: requiredRule(t)};
  }
})

watch(() => formData.value.groupCoachingEnabled, (val) => {
  if (!val) {
    formData.value.groupCoachingEmail = null
    rules.value = {...rules.value, groupCoachingEmail: ''};
  } else {
    // rules.value = {...rules.value, groupCoachingEmail: requiredRule(t)};
  }
})

watch(() => formData.value.socioTherapyCoachingEnabled, (val) => {
  if (!val) {
    formData.value.socioTherapyCoachingEmail = null
    rules.value = {...rules.value, socioTherapyCoachingEmail: ''};
  } else {
    // rules.value = {...rules.value, socioTherapyCoachingEmail: requiredRule(t)};
  }
})

watch(() => formData.value.privateLearningCoachingEnabled, (val) => {
  if (!val) {
    formData.value.privateLearningCoachingEmail = null
    rules.value = {...rules.value, privateLearningCoachingEmail: ''};
  } else {
    // rules.value = {...rules.value, privateLearningCoachingEmail: requiredRule(t)};
  }
})

watch(() => formData.value.assistedLivingCoachingEnabled, (val) => {
  if (!val) {
    formData.value.assistedLivingCoachingEmail = null
    rules.value = {...rules.value, assistedLivingCoachingEmail: ''};
  } else {
    // rules.value = {...rules.value, assistedLivingCoachingEmail: requiredRule(t)};
  }
})

watch(() => formData.value.caseManagementCoachingEnabled, (val) => {
  if (!val) {
    formData.value.caseManagementCoachingEmail = null
    rules.value = {...rules.value, caseManagementCoachingEmail: ''};
  } else {
    // rules.value = {...rules.value, caseManagementCoachingEmail: requiredRule(t)};
  }
})

onMounted(() => {
  loadSettings();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[64] || (_cache[64] = _createElementVNode("div", { class: "d-flex justify-content-between" }, [
            _createElementVNode("h6", { class: "element-header" }, "Firmeneinstellungen")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("form", {
              onSubmit: _withModifiers(submitForm, ["prevent"]),
              novalidate: ""
            }, [
              _createElementVNode("div", _hoisted_6, [
                _cache[55] || (_cache[55] = _createElementVNode("div", { class: "card-header bg-light border-bottom-0 py-3" }, [
                  _createElementVNode("h6", { class: "mb-0 fw-bold text-secondary" }, [
                    _createElementVNode("i", { class: "fa-solid fa-building section-icon" }),
                    _createTextVNode("Firmeninformationen ")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(BaseInput, {
                        modelValue: formData.value.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                        label: "Name",
                        required: true,
                        validation: _unref(v$)?.name,
                        messages: _unref(v$)?.name?.required?.$message
                      }, null, 8, ["modelValue", "validation", "messages"]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(BaseInput, {
                            modelValue: formData.value.city,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.city) = $event)),
                            label: "Stadt",
                            required: true,
                            validation: _unref(v$)?.city,
                            messages: _unref(v$)?.city?.required?.$message
                          }, null, 8, ["modelValue", "validation", "messages"])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(BaseInput, {
                            modelValue: formData.value.zip,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.zip) = $event)),
                            label: "PLZ",
                            required: true,
                            validation: _unref(v$)?.zip,
                            messages: _unref(v$)?.zip?.required?.$message
                          }, null, 8, ["modelValue", "validation", "messages"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(BaseInput, {
                            modelValue: formData.value.email,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.email) = $event)),
                            type: "email",
                            required: true,
                            label: "Email",
                            validation: _unref(v$)?.email,
                            messages: _unref(v$)?.email?.isValidEmail?.$message
                          }, null, 8, ["modelValue", "validation", "messages"])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(BaseInput, {
                            modelValue: formData.value.contactPerson,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.contactPerson) = $event)),
                            required: true,
                            label: "Ansprechpartner",
                            validation: _unref(v$)?.contactPerson,
                            messages: _unref(v$)?.contactPerson?.required?.$message
                          }, null, 8, ["modelValue", "validation", "messages"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(BaseInput, {
                            modelValue: formData.value.shortName,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.shortName) = $event)),
                            label: "Kurzname",
                            required: true,
                            validation: _unref(v$)?.shortName,
                            messages: _unref(v$)?.shortName?.required?.$message
                          }, null, 8, ["modelValue", "validation", "messages"])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(SelectedDropdown, {
                            modelValue: formData.value.companyKey,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.companyKey) = $event)),
                            options: _unref(companyKeys),
                            label: "Firmen-ID",
                            required: true,
                            validation: _unref(v$)?.companyKey,
                            messages: _unref(v$)?.companyKey?.required?.$message
                          }, null, 8, ["modelValue", "options", "validation", "messages"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(BaseInput, {
                            modelValue: formData.value.address,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.address) = $event)),
                            label: "Address",
                            required: true,
                            validation: _unref(v$)?.address,
                            messages: _unref(v$)?.address?.required?.$message
                          }, null, 8, ["modelValue", "validation", "messages"])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(BaseInput, {
                            modelValue: formData.value.houseNumber,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.houseNumber) = $event)),
                            label: "Hausnummer",
                            required: true,
                            validation: _unref(v$)?.houseNumber,
                            messages: _unref(v$)?.houseNumber?.required?.$message
                          }, null, 8, ["modelValue", "validation", "messages"])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(BaseInput, {
                            modelValue: formData.value.country,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.country) = $event)),
                            required: true,
                            label: "Land",
                            validation: _unref(v$)?.country,
                            messages: _unref(v$)?.country?.required?.$message
                          }, null, 8, ["modelValue", "validation", "messages"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(BaseInput, {
                            modelValue: formData.value.website,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.website) = $event)),
                            label: "Website",
                            required: true,
                            validation: _unref(v$)?.website,
                            messages: _unref(v$)?.website?.required?.$message
                          }, null, 8, ["modelValue", "validation", "messages"])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(BaseInput, {
                            required: true,
                            modelValue: formData.value.phoneNumber,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.phoneNumber) = $event)),
                            label: "Telefonnummer",
                            validation: _unref(v$)?.phoneNumber,
                            messages: _unref(v$)?.phoneNumber?.required?.$message
                          }, null, 8, ["modelValue", "validation", "messages"])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(BaseInput, {
                        modelValue: formData.value.registrationPlace,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.registrationPlace) = $event)),
                        required: true,
                        label: "Handelsregister (Ort)",
                        validation: _unref(v$)?.registrationPlace,
                        messages: _unref(v$)?.registrationPlace?.required?.$message
                      }, null, 8, ["modelValue", "validation", "messages"])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(BaseInput, {
                        modelValue: formData.value.registrationCourt,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.registrationCourt) = $event)),
                        required: true,
                        label: "Registergericht",
                        validation: _unref(v$)?.registrationCourt,
                        messages: _unref(v$)?.registrationCourt?.required?.$message
                      }, null, 8, ["modelValue", "validation", "messages"])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(BaseInput, {
                        modelValue: formData.value.registrationNumber,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.registrationNumber) = $event)),
                        required: true,
                        label: "Handelsregisternummer",
                        validation: _unref(v$)?.registrationNumber,
                        messages: _unref(v$)?.registrationNumber?.required?.$message
                      }, null, 8, ["modelValue", "validation", "messages"])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(BaseInput, {
                        modelValue: formData.value.instituteIdentifier,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.value.instituteIdentifier) = $event)),
                        required: true,
                        label: "Institutskennzeichen",
                        validation: _unref(v$)?.instituteIdentifier,
                        messages: _unref(v$)?.instituteIdentifier?.required?.$message
                      }, null, 8, ["modelValue", "validation", "messages"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(BaseInput, {
                        required: true,
                        modelValue: formData.value.managingDirector1,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.value.managingDirector1) = $event)),
                        label: "Geschäftsführer 1",
                        validation: _unref(v$)?.managingDirector1,
                        messages: _unref(v$)?.managingDirector1?.required?.$message
                      }, null, 8, ["modelValue", "validation", "messages"])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(BaseInput, {
                        modelValue: formData.value.managingDirector2,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.value.managingDirector2) = $event)),
                        label: "Geschäftsführer 2",
                        validation: _unref(v$)?.managingDirector2,
                        messages: _unref(v$)?.managingDirector2?.required?.$message
                      }, null, 8, ["modelValue", "validation", "messages"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _cache[56] || (_cache[56] = _createElementVNode("div", { class: "card-header bg-light border-bottom-0 py-3" }, [
                  _createElementVNode("h6", { class: "mb-0 fw-bold text-secondary" }, [
                    _createElementVNode("i", { class: "fa-solid fa-landmark section-icon" }),
                    _createTextVNode("Finanzielle und steuerliche Details ")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(BaseInput, {
                        required: true,
                        modelValue: formData.value.bank,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.value.bank) = $event)),
                        label: "Bank",
                        validation: _unref(v$)?.swift,
                        messages: _unref(v$)?.swift?.bank?.$message
                      }, null, 8, ["modelValue", "validation", "messages"])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(BaseInput, {
                        required: true,
                        modelValue: formData.value.swift,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formData.value.swift) = $event)),
                        label: "SWIFT/BIC",
                        validation: _unref(v$)?.swift,
                        messages: _unref(v$)?.swift?.required?.$message
                      }, null, 8, ["modelValue", "validation", "messages"])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createVNode(BaseInput, {
                        required: true,
                        modelValue: formData.value.iban,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formData.value.iban) = $event)),
                        label: "IBAN",
                        validation: _unref(v$)?.iban,
                        messages: _unref(v$)?.iban?.required?.$message
                      }, null, 8, ["modelValue", "validation", "messages"])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(BaseInput, {
                        modelValue: formData.value.taxNumber,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formData.value.taxNumber) = $event)),
                        required: true,
                        label: "Steuernummer",
                        validation: _unref(v$)?.taxNumber,
                        messages: _unref(v$)?.taxNumber?.required?.$message
                      }, null, 8, ["modelValue", "validation", "messages"])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(BaseInput, {
                        required: true,
                        modelValue: formData.value.accountingContactPerson,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((formData.value.accountingContactPerson) = $event)),
                        label: "Ansprechpartner für die Buchhaltung",
                        validation: _unref(v$)?.accountingContactPerson,
                        messages: _unref(v$)?.accountingContactPerson?.required?.$message
                      }, null, 8, ["modelValue", "validation", "messages"])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createVNode(BaseInput, {
                        modelValue: formData.value.accountingPhoneNumber,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((formData.value.accountingPhoneNumber) = $event)),
                        label: "Telefonnummer der Buchhaltung"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _createVNode(BaseInput, {
                        modelValue: formData.value.accountingEmail,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((formData.value.accountingEmail) = $event)),
                        label: "Buchhaltungs-E-Mail"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _cache[60] || (_cache[60] = _createElementVNode("div", { class: "card-header bg-light border-bottom-0 py-3" }, [
                  _createElementVNode("h6", { class: "mb-0 fw-bold text-secondary" }, [
                    _createElementVNode("i", { class: "fa-solid fa-palette section-icon" }),
                    _createTextVNode("Firmenlogo und Farbe ")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _cache[57] || (_cache[57] = _createElementVNode("label", { class: "fw-bold" }, "Firmenlogo", -1)),
                      _createVNode(BaseDropzoneImage, {
                        modelValue: logo.value,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((logo).value = $event)),
                        multiple: false,
                        height: 200,
                        text: "Firmenlogo hochladen.",
                        style: {"width":"100%","max-width":"300px","margin":"0 auto"},
                        class: "dropzone-image"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _cache[58] || (_cache[58] = _createElementVNode("label", { class: "fw-bold" }, "Vorschau", -1)),
                      _createElementVNode("div", _hoisted_50, [
                        (formData.value.logoUrl)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: formData.value.logoUrl,
                              alt: "Company Logo",
                              class: "p-2",
                              style: {"max-width":"100%","max-height":"100%","object-fit":"contain"}
                            }, null, 8, _hoisted_51))
                          : (_openBlock(), _createElementBlock("span", _hoisted_52, "Kein Logo geladen"))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _createVNode(BaseColorPicker, {
                        modelValue: formData.value.colorCode,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((formData.value.colorCode) = $event)),
                        label: "Firmenfarbe",
                        required: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _cache[59] || (_cache[59] = _createElementVNode("div", {
                          class: "text-muted mb-3 small fw-bold text-uppercase",
                          style: {"letter-spacing":"0.5px"}
                        }, [
                          _createElementVNode("i", { class: "os-icon os-icon-layout me-1" }),
                          _createTextVNode(" Menü-Einstellungen (Sidebar) ")
                        ], -1)),
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("div", _hoisted_57, [
                            _createVNode(BaseColorPicker, {
                              modelValue: formData.value.sidebarColorCode,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((formData.value.sidebarColorCode) = $event)),
                              label: "Menüfarbe",
                              required: true
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_58, [
                            _createVNode(BaseColorPicker, {
                              modelValue: formData.value.sidebarIconColorCode,
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((formData.value.sidebarIconColorCode) = $event)),
                              label: "Symbolfarbe",
                              required: true
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_59, [
                            _createVNode(BaseColorPicker, {
                              modelValue: formData.value.sidebarLinkColorCode,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((formData.value.sidebarLinkColorCode) = $event)),
                              label: "Linkfarbe",
                              required: true
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _cache[61] || (_cache[61] = _createElementVNode("div", { class: "card-header bg-light border-bottom-0 py-3" }, [
                  _createElementVNode("h6", { class: "mb-0 fw-bold text-secondary" }, [
                    _createElementVNode("i", { class: "fa-solid fa-toggle-on section-icon" }),
                    _createTextVNode("Module ")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _createVNode(BaseCheckbox, {
                        modelValue: formData.value.calendarEnabled,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((formData.value.calendarEnabled) = $event)),
                        label: "Calendar"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                      _createVNode(BaseCheckbox, {
                        modelValue: formData.value.timeManagementEnabled,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((formData.value.timeManagementEnabled) = $event)),
                        label: "Time Management"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_65, [
                      _createVNode(BaseCheckbox, {
                        modelValue: formData.value.clientEnabled,
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((formData.value.clientEnabled) = $event)),
                        label: "Kostenträger"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_66, [
                      _createVNode(BaseCheckbox, {
                        modelValue: formData.value.locationEnabled,
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((formData.value.locationEnabled) = $event)),
                        label: "Standorte"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _createVNode(BaseCheckbox, {
                        modelValue: formData.value.userEnabled,
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((formData.value.userEnabled) = $event)),
                        label: "Mitarbeiter"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_68, [
                      _createVNode(BaseCheckbox, {
                        modelValue: formData.value.unemployedEnabled,
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((formData.value.unemployedEnabled) = $event)),
                        label: "Kuunden"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_69, [
                      _createVNode(BaseCheckbox, {
                        modelValue: formData.value.travelExpensesEnabled,
                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((formData.value.travelExpensesEnabled) = $event)),
                        label: "Fahrtkosten"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _createVNode(BaseCheckbox, {
                        modelValue: formData.value.addressBookEnabled,
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((formData.value.addressBookEnabled) = $event)),
                        label: "Kontakte"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_71, [
                      _createVNode(BaseCheckbox, {
                        modelValue: formData.value.analyticsEnabled,
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((formData.value.analyticsEnabled) = $event)),
                        label: "Auswertung"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _createVNode(BaseCheckbox, {
                        modelValue: formData.value.deletedRecordsEnabled,
                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((formData.value.deletedRecordsEnabled) = $event)),
                        label: "Gelöschte Datensätze"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _createVNode(BaseCheckbox, {
                        modelValue: formData.value.aiDocumentScanEnabled,
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((formData.value.aiDocumentScanEnabled) = $event)),
                        label: "AI Dokumentenscan"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_74, [
                _cache[62] || (_cache[62] = _createElementVNode("div", { class: "card-header bg-light border-bottom-0 py-3" }, [
                  _createElementVNode("h6", { class: "mb-0 fw-bold text-secondary" }, [
                    _createElementVNode("i", { class: "fa-solid fa-list-check section-icon" }),
                    _createTextVNode("Maßnahmenn ")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("div", _hoisted_77, [
                      _createVNode(BaseCheckbox, {
                        modelValue: formData.value.privateCoachingEnabled,
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((formData.value.privateCoachingEnabled) = $event)),
                        label: "Einzelcoaching-Maßnahmenn"
                      }, null, 8, ["modelValue"]),
                      (formData.value.privateCoachingEnabled)
                        ? (_openBlock(), _createBlock(BaseInput, {
                            key: 0,
                            modelValue: formData.value.privateCoachingEmail,
                            "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((formData.value.privateCoachingEmail) = $event)),
                            type: "email",
                            placeholder: "Einzelcoaching Email",
                            validation: _unref(v$)?.privateCoachingEmail,
                            messages: _unref(v$)?.privateCoachingEmail?.required?.$message
                          }, null, 8, ["modelValue", "validation", "messages"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_78, [
                      _createVNode(BaseCheckbox, {
                        modelValue: formData.value.groupCoachingEnabled,
                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((formData.value.groupCoachingEnabled) = $event)),
                        label: "Gruppen Maßnahmen"
                      }, null, 8, ["modelValue"]),
                      (formData.value.groupCoachingEnabled)
                        ? (_openBlock(), _createBlock(BaseInput, {
                            key: 0,
                            modelValue: formData.value.groupCoachingEmail,
                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((formData.value.groupCoachingEmail) = $event)),
                            type: "email",
                            placeholder: "Gruppen Maßnahmen Email",
                            validation: _unref(v$)?.groupCoachingEmail,
                            messages: _unref(v$)?.groupCoachingEmail?.required?.$message
                          }, null, 8, ["modelValue", "validation", "messages"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_79, [
                      _createVNode(BaseCheckbox, {
                        modelValue: formData.value.socioTherapyCoachingEnabled,
                        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((formData.value.socioTherapyCoachingEnabled) = $event)),
                        label: "Soziotherapie Maßnahmen"
                      }, null, 8, ["modelValue"]),
                      (formData.value.socioTherapyCoachingEnabled)
                        ? (_openBlock(), _createBlock(BaseInput, {
                            key: 0,
                            modelValue: formData.value.socioTherapyCoachingEmail,
                            "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((formData.value.socioTherapyCoachingEmail) = $event)),
                            type: "email",
                            placeholder: "Soziotherapie Maßnahmen Email",
                            validation: _unref(v$)?.socioTherapyCoachingEmail,
                            messages: _unref(v$)?.socioTherapyCoachingEmail?.required?.$message
                          }, null, 8, ["modelValue", "validation", "messages"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_80, [
                      _createVNode(BaseCheckbox, {
                        modelValue: formData.value.privateLearningCoachingEnabled,
                        "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((formData.value.privateLearningCoachingEnabled) = $event)),
                        label: "Private Weiterbildungen"
                      }, null, 8, ["modelValue"]),
                      (formData.value.privateLearningCoachingEnabled)
                        ? (_openBlock(), _createBlock(BaseInput, {
                            key: 0,
                            modelValue: formData.value.privateLearningCoachingEmail,
                            "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((formData.value.privateLearningCoachingEmail) = $event)),
                            type: "email",
                            placeholder: "Private Weiterbildungen Email",
                            validation: _unref(v$)?.privateLearningCoachingEmail,
                            messages: _unref(v$)?.privateLearningCoachingEmail?.required?.$message
                          }, null, 8, ["modelValue", "validation", "messages"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_81, [
                      _createVNode(BaseCheckbox, {
                        modelValue: formData.value.assistedLivingCoachingEnabled,
                        "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((formData.value.assistedLivingCoachingEnabled) = $event)),
                        label: "Betreutes Wohnen"
                      }, null, 8, ["modelValue"]),
                      (formData.value.assistedLivingCoachingEnabled)
                        ? (_openBlock(), _createBlock(BaseInput, {
                            key: 0,
                            modelValue: formData.value.assistedLivingCoachingEmail,
                            "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((formData.value.assistedLivingCoachingEmail) = $event)),
                            type: "email",
                            placeholder: "Betreutes Wohnen Email",
                            validation: _unref(v$)?.assistedLivingCoachingEmail,
                            messages: _unref(v$)?.assistedLivingCoachingEmail?.required?.$message
                          }, null, 8, ["modelValue", "validation", "messages"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_82, [
                      _createVNode(BaseCheckbox, {
                        modelValue: formData.value.caseManagementCoachingEnabled,
                        "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((formData.value.caseManagementCoachingEnabled) = $event)),
                        label: "DRV Fallmanagement"
                      }, null, 8, ["modelValue"]),
                      (formData.value.caseManagementCoachingEnabled)
                        ? (_openBlock(), _createBlock(BaseInput, {
                            key: 0,
                            modelValue: formData.value.caseManagementCoachingEmail,
                            "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((formData.value.caseManagementCoachingEmail) = $event)),
                            type: "email",
                            placeholder: "DRV Fallmanagement Email",
                            validation: _unref(v$)?.caseManagementCoachingEmail,
                            messages: _unref(v$)?.caseManagementCoachingEmail?.required?.$message
                          }, null, 8, ["modelValue", "validation", "messages"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_83, [
                _cache[63] || (_cache[63] = _createElementVNode("div", { class: "card-header bg-light border-bottom-0 py-3" }, [
                  _createElementVNode("h6", { class: "mb-0 fw-bold text-secondary" }, [
                    _createElementVNode("i", { class: "fa-solid fa-file-invoice section-icon" }),
                    _createTextVNode("Rechnungslegung ")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_84, [
                  _createElementVNode("div", _hoisted_85, [
                    _createElementVNode("div", _hoisted_86, [
                      _createVNode(BaseCheckbox, {
                        modelValue: formData.value.billingEnabled,
                        "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((formData.value.billingEnabled) = $event)),
                        label: "Rechnungslegung"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_87, [
                      _createVNode(BaseCheckbox, {
                        modelValue: formData.value.coachBillingEnabled,
                        "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((formData.value.coachBillingEnabled) = $event)),
                        label: "Externe Coachabrechnung"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              _createVNode(ValidationErrorMessage, {
                validationErrors: _unref(v$)?.$errors
              }, null, 8, ["validationErrors"]),
              _createElementVNode("div", _hoisted_88, [
                _createVNode(SaveButton, {
                  label: _ctx.$t('general.button.save'),
                  loading: isSubmitting.value
                }, null, 8, ["label", "loading"])
              ])
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}
}

})